import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../axiosConfig";
import CatalogForm from "./CatalogForm";

export default function CatalogCreate() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (form) => {
    setSubmitting(true);
    try {
      const res = await api.post("/catalog/", form);
      if (res.data?.id) {
        navigate(`/catalog/${res.data.id}`);
      } else {
        navigate("/catalog");
      }
    } catch (err) {
      alert("Eroare la crearea catalogului: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-dark fw-bold m-0">Adaugă Catalog Nou</h2>
        <Button variant="outline-secondary" onClick={() => navigate("/catalog")}>
          Înapoi la listă
        </Button>
      </div>
      <CatalogForm onSubmit={handleSubmit} submitting={submitting} />
    </Container>
  );
}
